export const COLOR_HEX = {
  White: "#FFFFFF",
  Black: "#111111",
  "Navy Blue": "#1E3A5F",
  "Sky Blue": "#7DD3FC",
  "Royal Blue": "#2563EB",
  Orange: "#F97316",
  Red: "#DC2626",
  "Mango Yellow": "#F59E0B",
  "Golden Yellow": "#EAB308",
  "Lemon Yellow": "#FDE047",
  "Parrot Green": "#4ADE80",
};

export const ALL_COLORS = Object.keys(COLOR_HEX);
